@if (svgName.includes('default')) {
  <div class="svg-icon-wrapper">
    <i class="fa-kit fa-imageicon1"></i>
  </div>
} @else {
  <div class="svg-icon-wrapper" [innerHTML]="svgContent()" [style.height]="svgHeight" [style.width]="svgWidth"></div>
}